import "./login.css";
import templeIcon from "../../assets/images/BELL.gif";
import { FaLock, FaEyeSlash, FaEye, FaUserAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { login } from "../../services/auth.service";
import Swal from "sweetalert2";

const LoginComponent = () => {

    const navigate = useNavigate();
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [initialValues] = useState({ username: "", password: "" });
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get("sessionExpired") !== "true") return;

        window.history.replaceState({}, document.title, window.location.pathname);
        Swal.fire({
            icon: "warning",
            title: "Session Expired",
            text: "Your session has expired. Please sign in again to continue.",
            confirmButtonText: "Sign In Again",
            confirmButtonColor: "#2b53a3",
            allowOutsideClick: false,
            allowEscapeKey: false,
        });
    }, []);

    const validationSchema = Yup.object().shape({
        username: Yup.string()
            .required("Username is required")
            .min(3, "Username must be at least 3 characters")
            .max(30, "Username must not exceed 30 characters"),
        password: Yup.string()
            .required("Password is required")
            .min(3, "Password must be at least 3 characters")
            .max(20, "Password must not exceed 20 characters"),
    });

    const showError = (msg) => {
        setMessage(msg);
        setTimeout(() => setMessage(''), 3000);
    };

    const handleLoginSubmit = async (values) => {
        setMessage("");
        setLoading(true);
        const username = values.username;
        const password = values.password;

        try {
            const response = await login(username, password);

            if (response.success) {
                const redirectPath = sessionStorage.getItem("redirectAfterLogin");
                if (redirectPath) {
                    sessionStorage.removeItem("redirectAfterLogin");
                    navigate(redirectPath);
                } else {
                    navigate("/dashboard");
                }
            } else {
                showError(response.message || "Login failed");
            }
        } catch (error) {
            console.error("Login error:", error);
            let resMessage = "Something went wrong, please try again!";

            if (error.response) {
                const status = error.response.status;
                const backendMessage = error.response.data?.message;
                if (typeof backendMessage === "string" && backendMessage.trim()) {
                    resMessage = backendMessage;
                } else if (status === 401) resMessage = "Invalid username or password";
                else if (status === 403) resMessage = "Your account is locked or disabled";
                else if (status === 400) resMessage = "Invalid input format";
                else if (status === 500) resMessage = "Server error during authentication";
            }

            showError(resMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleSignup = () => {
        navigate('/sign-up');
    };

    return (
        <div>
            <div className="login-body">
                <div className="container d-flex align-items-center justify-content-center min-vh-100">
                    <div className="login-wrapper p-4 rounded-4 shadow-lg bg-white text-dark">
                        <div className="text-center mb-3">
                            <img src={templeIcon} alt="Temple" className="temple-icon mb-2" />
                            <h3 className="fw-bold temple-text">Temple Management System</h3>
                            <p className="text-muted small">Welcome to the Divine Portal</p>
                        </div>
                        {message && (
                            <div className="alert alert-danger text-center" role="alert">
                                {message}
                            </div>
                        )}
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleLoginSubmit}
                        >
                            {({ errors, touched }) => (
                                <Form className="login-form">
                                    <div className="mb-3 custom-label">
                                        <label className="signup-label">Username</label>
                                        <div className="signup-input-box">
                                            <FaUserAlt className="signup-icon" />
                                            <Field
                                                type="text"
                                                name="username"
                                                className="signup-input"
                                                placeholder="Enter Username or Mobile No"
                                            />
                                        </div>
                                        <ErrorMessage name="username" component="div" className="text-danger" />
                                    </div>

                                    <div className="mb-3 custom-label">
                                        <label className="signup-label">Password</label>
                                        <div className="signup-input-box">
                                            <FaLock className="signup-icon" />
                                            <Field
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                className="signup-input"
                                                placeholder="Enter Password"
                                            />
                                            <span
                                                className="signup-eye"
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                        <ErrorMessage name="password" component="div" className="text-danger" />
                                        <div className="d-flex justify-content-end mt-1">
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 text-decoration-none small text-secondary"
                                                onClick={() => navigate('/forgot-password')}
                                            >
                                                Forgot Password?
                                            </button>
                                        </div>
                                    </div>

                                    <div className="d-grid mt-4">
                                        <button type="submit"
                                            className="btn btn-warning btn-lg rounded-pill fw-medium"
                                            disabled={loading}
                                        >
                                            {loading && (
                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                            )}
                                            Sign In
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                        <div className="text-center mt-3">
                            <small>Create an account?</small>{" "}
                            <button
                                className="btn btn-link p-0 text-decoration-none fw-medium"
                                onClick={handleSignup}
                            >
                                Sign Up
                            </button>
                        </div>
                        <p className="text-center mt-3 text-muted small">© {new Date().getFullYear()} TMS</p>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default LoginComponent;
